<template>
  <div class="Search">
    <div class="h-t">
      <div class="fix-win" :style="scrollTopM">
        <div style="height:36px;"></div>
        <div class="search-input">
          <el-input placeholder="请输入职位名称关键字" style="font-size:16px;" v-model="searchVal" class="input-with-select" clearable>
            <el-button slot="append" icon="el-icon-search" @click="searchJobs">搜索</el-button>
          </el-input>
        </div>
        <div v-if='show' class="search-win">
          <div class="win-item">
            <div class="item-l">发布时间：</div>
            <div class="item-r">
              <el-select v-model="dateVal" placeholder="请选择" >
                <el-option v-for="item in dateOption" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="win-item">
            <div class="item-l">工作地点：</div>
            <div class="item-r">
              <el-select v-model="province" value-key='id' placeholder="请选择" @change="locationSelect">
                <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item">
                </el-option>
              </el-select> <span style="font-weight:bold;padding:0 12px;">></span>
              <el-select v-model="city" value-key='id' placeholder="请选择">
                <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="win-item">
            <div class="item-l">学历要求：</div>
            <div class="item-r">
              <template v-for="(item,index) in clutureDegree">
                <span class="tar" :class="{'is-active':index==currentIndex}" @click="selectCultureItem(index,item)" :key="item">{{item}}</span>
              </template>
            </div>
          </div> -->
          <div class="win-item">
            <div class="item-l">薪资范围：</div>
            <div class="item-r">
              <el-select v-model="slaryStart" placeholder="请选择" clearable>
                <el-option v-for="item in slarys" :key="item" :label="item" :value="item">
                </el-option>
              </el-select> <span style="font-weight:bold;padding:0 12px;">~</span>
              <el-select v-model="slaryEnd" placeholder="请选择" clearable>
                <el-option v-for="item in slarys" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="win-item" style="height: 64px;">
            <div class="item-l">岗位类型：</div>
            <div class="item-r" style='line-height:22px;'>
              <span :class="['tar',{'is-active':jobType==0}]" @click="handleSpanClick(0,'不限')">不限</span>
              <template v-for="item in jobTypes">
                <span :class="['tar',{'is-active':jobType==item.id}]" :key="item.id" @click="handleSpanClick(item.id,item.value)">{{item.value}}</span>
              </template>
            </div>
          </div>
          <div class="win-item">
            <div class="item-l">公司名称：</div>
            <div class="item-r">
              <el-input v-model="company" style="width:360px;" placeholder="请输入公司关键字"></el-input>
            </div>
          </div>
          <div class="div" @click="colseWin">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div v-else class="search-win">
          <div style="font-size:14px;text-align:left">
            <span style="font-weight:bold">发布时间:</span>
            <span>{{this.dateVal}}</span>;
            <span style="font-weight:bold">工作地点:</span>
            <span>{{this.province.name+' > '+this.city.name}}</span>;
            <!-- <span style="font-weight:bold">学历要求:</span> -->
            <!-- <span>{{this.education}}</span>; -->
            <span style="font-weight:bold">薪资范围:</span>
            <span>{{this.slaryStart+'~'+this.slaryEnd}}</span>;
            <span style="font-weight:bold">岗位类型:</span>
            <span>{{this.jobTypeVal}}</span>;
            <span style="font-weight:bold">公司名称:</span>
            <span>{{this.company}}</span>;
          </div>
          <div class="div" @click="colseWin">
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div class="item">
        <!-- <Jobs :isTop="true" />  -->

      </div>

    </div>
    <!-- <div class="h-b">
      <div class="item">
        <div class="item-l">
          <img src="../assets/image/wbyx.png" />
        </div>
        <div class="item-r">
          <el-menu :default-active="activeIndex" router class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="/">首页/Home</el-menu-item>
            <el-menu-item index="/ContactUs" >联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Jobs from './Jobs.vue';

export default {
  name: 'Search',
  data() {
    return {
      dateOption: ['最近一个月', '最近三个月', '最近半年', '最近一年'],
      clutureDegree: ['不限', '技校', '中专', '大专', '本科及以上'],
      value: '',
      proList: [],
      searchVal: '',
      activeIndex: '/',
      dateVal: '最近三个月',
      provinces: [],
      citys: [{ id: 0, name: '全境' }],
      province: { id: 0, name: '全国' },
      city: { id: 0, name: '全境' },
      slaryStart: '',
      slaryEnd: '',
      slarys: [ '1k', '2k', '3k', '4k', '5k', '6k', '7k', '8k', '9k', '10k'],
      currentIndex: 0,
      show: true,
      scrollTop: 0,
      education: '不限',
      jobType: 0,
      jobTypeVal:'不限',
      jobTypes: [],
      company:''
    };
  },
  components: {
    Jobs,
  },
  created() {},
  mounted() {
    // this.getStudentApply()
    window.addEventListener('scroll', this.handleScroll, true);
    // this.$emit('setVal');
    this.getProvinces();
    this.getJobList();
    // setTimeout(this.winMove, 1000);
  },
  updated(){
      this.$emit('setVal');
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    scrollTopM() {
      return this.scrollTop > 100 ? 'box-shadow:0px 2px 2px 0px #ccc' : 'box-shadow:unset';
    },
  },
  methods: {
    handleSpanClick(id,value){
      this.jobType = id
      this.jobTypeVal=value
    },
    searchJobs() {
      this.$emit('searchJobmain');
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.scrollTop)
      if (this.scrollTop > 100) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    async getJobList() {
      let res = await this.$api.instance.getJobList();
      if (res.code == 0) {
        this.jobTypes = res.data;
      }
    },
    colseWin() {
      this.show = !this.show;
    },
    async getProvinces() {
      let res = await this.$api.instance.getProvince();
      if (res.code == 0) {
        let arr = res.data.reverse();
        arr.push({ id: 0, name: '全国' });
        this.provinces = arr.reverse();
      }
    },
    async getCitys(id) {
      let res = await this.$api.instance.getCity(id);
      if (res.code == 0) {
        let arr = res.data.reverse();
        arr.push({ id: id, name: '全境' });
        this.citys = arr.reverse();
        this.city = this.citys[0];
      }
    },
    selectCultureItem(index, item) {
      this.currentIndex = index;
      this.education = item;
    },
    locationSelect(val) {
      if (!val.id) {
        this.citys = [{ id: 0, name: '全境' }];
        this.city = { id: 0, name: '全境' };
        return;
      }
      this.getCitys(val.id);
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
.Search {
  /deep/.el-input__icon{
    line-height: 25px;
  }
  // background: #b75d5d;
  width: 100%;
  // height: 120px;
  min-width: 1280px;
  position: relative;
  padding-top: 42px;
  .h-t {
    // height: 42px;
    // background: #111111;
    // color: #d9d9d9;
    font-size: 12px;
    .fix-win {
      position: fixed;
      z-index: 999;
      width: 100%;
      background: #fff;
      padding: 0 0 24px;
      top: 40px;
      .search-input {
        width: 1200px;
        margin: 0 auto;
        /deep/.el-input__inner {
          border-radius: 0px;
          box-shadow: 0 0 2px #798f9e inset;
          height: 48px;
          line-height: 48px;
        }
        /deep/.el-input-group__append {
          border-radius: 0;
          padding: 12px 44px;
          background-color: #619cc5;
          color: #fff;
          border: 1px solid #619cc5;
        }
      }
    }
    .search-win {
      width: 1136px;
      margin: 16px auto;
      border-bottom: 1px solid #619cc5;
      border-radius: 24px;
      padding: 16px 32px;
      border-top: 1px solid #619cc5;
      position: relative;
      span + span {
        margin-left: 8px;
      }
      .div {
        width: 40px;
        height: 20px;
        background: #fff;
        position: absolute;
        bottom: -21px;
        line-height: 20px;
        font-weight: bold;
        font-size: 14px;
        right: 50%;
        border: 1px solid #619cc5;
        border-top: none;
        text-align: center;
        color: #619cc5;
        cursor: pointer;
      }
      .s-title {
        font-size: 14px;
        font-weight: bold;
      }
      .s-item {
      }
      .win-item {
        display: flex;
        text-align: left;
        // margin-bottom: 8px;
        .item-l {
          width: 72px;
          font-size: 14px;
          font-weight: bold;
          height: 36px;
          line-height: 36px;
        }
        .item-r {
          flex: 1;
          height: 36px;
          line-height: 36px;

          /deep/.el-input__inner {
            height: 28px;
            line-height: 28px;
            box-shadow: unset;
            border: 1px #ccc solid;
          }
          .tar {
            padding: 0px 8px;
            font-size: 14px;
            margin: 4px 2px;
            cursor: pointer;
            display: inline-block;
          }
          .tar:hover {
            background: #619cc5;
            color: #fff;
          }
          .is-active {
            background: #619cc5;
            color: #fff;
          }
        }
      }
    }
    .item {
      width: 1200px;
      text-align: left;
      // line-height: 42px;
      // display: flex;
      margin: 0 auto;
      margin-top: 382px;

      position: relative;
    }
  }
  .h-b {
    height: 88px;
    background: #ffffff;
    .item {
      width: 1200px;
      // line-height: 88px;
      height: 88px;
      display: flex;
      margin: 0 auto;
      .item-l {
        width: 45%;
        // line-height: 88px;
        text-align: left;
        display: flex;
        img {
          width: 150px;
          height: 64px;
          margin-top: 12px;
          // vertical-align: middle;
        }
        div {
          padding-left: 16px;
          p:first-child {
            font-size: 24px;
            margin-top: 20px;
            letter-spacing: 8px;
          }
          p {
            font-size: 12px;
            letter-spacing: 3px;
          }
        }
      }
      .item-r {
        text-align: right;
        width: 55%;
        /deep/.el-menu {
          height: 100%;
          border-bottom: 0;
          .el-menu-item {
            height: 88px;
            font-size: 18px;
            line-height: 88px;
            padding: 0 31px;
            color: #666;
            border: 0;
          }
        }
      }
    }
  }
}
/deep/.el-menu.el-menu--horizontal {
  border: 0;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  border: 0;
  background: #307fbb !important;
  color: #fefefe !important;
}
/deep/.el-menu-item:hover {
  color: #307fbb !important;
}
</style>
